import { createGlobalStyle } from 'styled-components'

const GlobalStyle = createGlobalStyle`  
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  
  #root {
    height: 100%;
  }
  ._loading_overlay_wrapper {
 display: table;
 width: 100%;
 height: 100px;
 min-height: 100%;
  }
  //.css-79elbk {
  // overflow: scroll;
  //}
  //.css-ft4slc {
  // overflow: scroll;
  //}
  h1, h2, h3, h4, h5, h6 {
   color: #152735;
  }
  
  h1 {
    font-size: 30px;
  }
  
  h2 {
    font-size: 24px;
  }
  
  h3 {
    font-size: 21px;
  }
  
  h4 {
    font-size: 18px;
  } 
  
  h5 {
    font-size: 15px;
  }
  
  h6 {
    font-size: 14px;
  }
  
  p {
    color: #585D64;
    font-size: 14px;
  }
  
  html,
  body {  
    height: 100%;
    background-color: #EBEFF5;
    font-family: Montserrat;
  }
  
  .navbar {
    display: flex;
    align-items: center;
    background: linear-gradient(177.61deg, #3db8f1 0%,#7db9e8 100%);
    min-height: 110px;
  }
  
  .wrapper {
    display: flex;
    flex-direction: column;
    min-height: 100%;
  }
  
  .content {
    flex: 1 0 auto;
  }
  
  .footer {
    flex: 0 0 auto;
    padding: 1rem 0;
    min-height: 105px;
    border-top: 1px solid #D5D8DE;
    background: #E6EAF0;
  }
`

export default GlobalStyle
